<template>
    <div data-container>
        <div
            v-if="unsupportedPage.name === `IE` || unsupportedPage.name === `Edge`"
            class="notranslate"
            data-text
        >
            <div data-unsupported>
                <h1>{{$store.getters.textResource(`rs_unsupported_title`)}}</h1>
                <p>{{$store.getters.textResource(`rs_unsupported_text`)}}</p>
                <p>
                    {{$store.getters.textResource(`rs_unsupported_text_part2`)}}
                    <a
                        href="https://www.microsoft.com/edge"
                    >{{$store.getters.textResource(`rs_unsupported_text_part3`)}}</a>
                </p>
                <div data-browsers>
                    <div v-for="browser in supportedBrowsers" data-image :key="browser.name">
                        <a :href="browser.url">
                            <media
                                :url="`${state.settings.assetPath}${browser.name}-logo.png`"
                                :alt="`${browser.name} Logo`"
                                type="Image"
                            />
                            <div>{{browser.name}}</div>
                        </a>
                    </div>
                </div>
            </div>
            <p data-copy-text>{{$store.getters.textResource(`rs_unsupported_link`)}}</p>
            <div data-qlink tabindex="0" @keydown.space="copyURL">
                <span>{{queueLink}}</span>
                <font-awesome-icon
                    data-icon
                    icon="copy"
                    aria-hidden="true"
                    @click.stop.prevent="copyURL"
                />
                <input data-only-screenreader type="text" id="qlink" :value="queueLink" />
            </div>
            <p data-copy role="alert">{{copied}}</p>
        </div>
        <div
            v-else-if="unsupportedPage.name === 'Safari' && unsupportedPage.version < 10"
            data-container
            class="notranslate"
        >
            <div data-unsupported aria-live="assertive" aria-relevant="additions">
                <h1>{{$store.getters.textResource(`rs_unsupported_title_safari`)}}</h1>
                <p>{{$store.getters.textResource(`rs_unsupported_text_safari`)}}</p>
                <p>{{$store.getters.textResource(`rs_unsupported_text_safari_part2`)}}</p>
                <div data-browser>
                    <media
                        data-safari
                        :url="`${state.settings.assetPath}safari-logo.png`"
                        :alt="`${unsupportedPage.name} Logo`"
                        type="Image"
                    />
                </div>
                <p data-copy-text>{{$store.getters.textResource(`rs_unsupported_link`)}}</p>
                <div data-qlink tabindex="0" @click.stop.prevent="copyURL">
                    <span>{{ queueLink }}</span>
                    <font-awesome-icon data-icon icon="copy" aria-hidden="true" />
                    <input
                        data-only-screenreader
                        type="text"
                        id="qlink"
                        :value="queueLink"
                        @keydown.space="copyURL"
                    />
                </div>
                <p data-copy role="alert">{{copied}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import methods from "@/global/methods.js";
import media from "@/components/Media.vue";

export default {
    name: `unsupported-page`,
    components: {
        media,
    },
    data: function () {
        return {
            supportedBrowsers: [
                {
                    name: `Chrome`,
                    url: `https://www.chrome.com`,
                },
                {
                    name: `Firefox`,
                    url: `https://www.mozilla.org/`,
                },
                {
                    name: `Edge`,
                    url: `https://www.microsoft.com/edge`,
                },
                {
                    name: `Opera`,
                    url: `https://www.opera.com/`,
                },
            ],
            copied: ``,
            queueLink: document.location.href,
        };
    },
    computed: {
        state: function () {
            return this.$store.state;
        },
        unsupportedPage: function () {
            return methods.getBrowser();
        },
    },
    methods: {
        getUnsupportedPageModel: function () {
            methods.xhr({
                type: "GET",
                url: "/v1/Queue/GetUnsupportedPageModel?surveyId=" + this.state.surveyInfo.surveyId,
                callback: (xhr) => {
                    let response = JSON.parse(xhr.responseText);
                    this.$store.dispatch("loadText", response.culture);
                },
            });
        },
        copyURL() {
            let copyText = document.getElementById("qlink");
            copyText.setAttribute("type", "text");
            copyText.select();

            try {
                document.execCommand("copy");
                this.copied = this.$store.getters.textResource(`rs_url_copied`);
            } catch (err) {
                this.copied = this.$store.getters.textResource(`rs_unable_to_copy`);
            }

            copyText.setAttribute("type", "hidden");
            window.getSelection().removeAllRanges();
        },
    },
    created: function () {
        this.getUnsupportedPageModel();
    },
};
</script>

<style>
[data-container] {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
}

[data-text] {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 5px;
}

[data-copy-text] {
    margin-top: 35px;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size: 14px;
}

[data-qlink] {
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    background: rgb(230, 230, 230);
    border-radius: 5px;
    padding: 6px;
    border-style: solid;

    [data-icon] {
        margin-left: 12px;
        cursor: pointer;
    }
}

[data-copy] {
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}

[data-unsupported] {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    font-family: Verdana, Geneva, Tahoma, sans-serif;

    h1 {
        font-size: 25px;
        text-align: center;
        padding: 0 15px 0 15px;
        color: rgb(75, 73, 73);
        width: 100%;
    }

    p {
        width: 100%;
        text-align: center;
        padding: 0 15px 0 15px;
        font-size: 14px;
        margin-top: 0;
    }

    [data-safari] {
        width: 80px;
    }

    [data-browsers] {
        display: flex;
        width: 100%;
        justify-content: space-around;
        padding-top: 7px;
        align-items: center;
        max-width: 600px;

        [data-image] {
            height: 100%;

            a {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-decoration: none;
            }

            &:hover {
                transition: 0.2s;
                transform: scale(1.05);
            }

            img {
                width: 60px;
            }
        }
    }
}
</style>